export default __webpack_public_path__ + "static/media/newbie_project7.aa159c07.jpg";